import styled from 'styled-components'

export const Table = styled.table`
  border-spacing: 0;
  max-width: 100%;
  width: 100%;

  table-layout: fixed;
`

export const TableCell = styled.td`
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: 22px;
  border-bottom: 2px solid #dbdbdb;
  padding: 16px 0;

  text-align: ${props => props.align};

  color: ${props => props.color};

  font-weight: ${props => props.fontWeight};
`
TableCell.defaultProps = {
  align: 'center',
  color: '#3D3D3D',
  fontWeight: 'normal',
  fontSize: '16px',
}

export const TableFooter = styled.tfoot`
  tr:last-child ${TableCell} {
    border-bottom: none;
  }
`
